import { render, staticRenderFns } from "./CreateDonationReceipt.vue?vue&type=template&id=8a268734&"
import script from "./CreateDonationReceipt.vue?vue&type=script&lang=js&"
export * from "./CreateDonationReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports